export enum AlarmFilterEnum{
  ALARM,
  BATTERY,
  FIRE,
  OUT_OF_BED,
  FRIDGE,
  IN_BED,
  SELFCHECK,
  OUT_OF_BATTERY,
  OUTDATED_POSITION,
  GEOFENCE,
  STATIC,
  OFFLINE,
  TCP_DISABLED,
  CHARGING,
  GENERAL,
  AC_FAIL,
  SENSOR_SUPERVISION_FAILURE,
  SENSOR_TAMPER,
  NEVER_USED,
  CLEAR,
  TECHNICAL,
  OK,
  SENSOR_LOW_BATTERY,
}